import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import * as Hjson from 'hjson';

// imports for membership component
const States = '../../../assets/jsons/membershipLists/states.json';
const Academic_program_list = '../../../assets/jsons/membershipLists/academic_program_list.json';
const Degree_being_pursued_list = '../../../assets/jsons/membershipLists/degree_being_pursued_list.json';
const Employer_types = '../../../assets/jsons/membershipLists/employer_types.json';
const Field_studies = '../../../assets/jsons/membershipLists/field_studies.json';
const Job_function_list = '../../../assets/jsons/membershipLists/job_function_list.json';
const Primary_bussiness_list = '../../../assets/jsons/membershipLists/primary_bussiness_list.json';
const Responsibility_list = '../../../assets/jsons/membershipLists/responsibility_list.json';
const Technology_focus_list = '../../../assets/jsons/membershipLists/technology_focus_list.json';
const Titles = '../../../assets/jsons/membershipLists/titles.json';
const Universites = '../../../assets/jsons/membershipLists/universites.json';
const costs = '../../../assets/jsons/membershipLists/membrships_costs.json';
const payment = '../../../assets/jsons/membershipLists/payment.json';

// Home JSONs
const mainSlideshow = '../../../assets/jsons/home/mainSlideshow.json';
const about = '../../../assets/jsons/home/about.json';
const infoSlideshow = '../../../assets/jsons/home/infoSlideshow.json';
const studentBranches = '../../../assets/jsons/home/studentBranches.json';
const links = '../../../assets/jsons/home/bottomBarLinks.json';

// Student Branch
const studentBranchesText = '../../../assets/jsons/studentBranches/text.json';
import { studentBranchesPages } from '../../../assets/jsons/studentBranches/pages';
const studentBranchesCards = '../../../assets/jsons/studentBranches/cards.json';


// Pages Titles And Descriptions
const signUp = '../../../assets/jsons/signup/signUp.json';
const contactUs = '../../../assets/jsons/contactUs/contactUs.json';
const blog = '../../../assets/jsons/blog/blog.json';

const aboutUs = '../../../assets/jsons/aboutUs/aboutUs.json';
 


@Injectable({
  providedIn: 'root' 
})
export class JsonService {

  reader = new FileReader();
  constructor(private http: HttpClient) { 
    
  }


  printJSON(){
    // let test = this.membershipLists()
    // console.log(test);
    // console.log(test.states);


  }

  get(path:string): Observable<any>{
    return this.http.get(path);
  }

  // membershipLists(){
  //   let states = (States as any).default
  //   let academic_program_list = (Academic_program_list as any).default;
  //   let degree_being_pursued_list = (Degree_being_pursued_list as any).default;
  //   let employer_types = (Employer_types as any).default;
  //   let field_studies = (Field_studies as any).default;
  //   let job_function_list = (Job_function_list as any).default;
  //   let primary_bussiness_list = (Primary_bussiness_list as any).default;
  //   let responsibility_list = (Responsibility_list as any).default;
  //   let technology_focus_list = (Technology_focus_list as any).default;
  //   let titles = (Titles as any).default;
  //   let universites = (Universites as any).default;
    
  //   let res =  {
  //     states,
  //     academic_program_list,
  //     degree_being_pursued_list,
  //     employer_types,
  //     field_studies,
  //     job_function_list,
  //     primary_bussiness_list,
  //     responsibility_list,
  //     technology_focus_list,
  //     titles,
  //     universites
  //   };

  //   JSON.stringify(res);

  //   return res;
    
  // }

  getStates(){
    return this.get(States);
  }
  getAcademicProgramList(){
    return this.get(Academic_program_list);
  }
  getDegreeBeingPursuedList(){
    return this.get(Degree_being_pursued_list);
  }
  getEmployerTypes(){
    return this.get(Employer_types);
  }
  geFieldStudies(){
    return this.get(Field_studies);
  }
  getJobFunctionList(){
    return this.get(Job_function_list);
  }
  getPrimaryBussinessList(){
    return this.get(Primary_bussiness_list);
  }
  getResponsibilityList(){
    return this.get(Responsibility_list);
  }
  getTechnologyFocusList(){
    return this.get(Technology_focus_list);
  }
  getTitles(){
    return this.get(Titles);
  }
  getUniversites(){
    return this.get(Universites);
  }


  getMembershipsPayment(){
    return this.get(payment);
    // let _payment = (payment as any).default;
    // return _payment;
  }


  getMembershipsCosts(){
    return this.get(costs);
    // let _costs = (costs as any).default;
    // return _costs;
  }

  // Home JSONs
  getMainSlideshows(){
    return this.get(mainSlideshow);
    // let _mainSlideshow = (mainSlideshow as any).default;
    // return _mainSlideshow;
  }

  getAbout(){
    return this.get(about);
    // let _about = (about as any).default;
    // return _about;
  }
  getInfoSlideshows(){
    return this.get(infoSlideshow);
    // let _infoSlideshow = (infoSlideshow as any).default;
    // return _infoSlideshow;
  }
  getStudentBranches(){
    return this.get(studentBranches);
    // let _studentBranches = (studentBranches as any).default;
    // return _studentBranches;
  }
  getLinks(){

    return this.get(links);
    // let _links = (links as any).default;
    // return _links;
  }

  // student Branches JSONs
  getStudentBranchesText(){
    return this.get(studentBranchesText);
    // let _studentBranchesText = (studentBranchesText as any).default;
    // return _studentBranchesText;
  }
  getStudentBranchesCards(){
    return this.get(studentBranchesCards);
    // let _studentBranchesCards = (studentBranchesCards as any).default;
    // return _studentBranchesCards;
  }
  getStudentBranchesPages(sb){
    const _studentBranchesPages = import("../../../assets/jsons/studentBranches/pages");
    //const _studentBranchesPages = () => import('../../../assets/jsons/studentBranches/pages');
    // import('../../../assets/jsons/studentBranches/pages').then(({default: myData}) => myData);
    // _studentBranchesPages.then((libFunc) => {
    //   libFunc();
    // });
    return _studentBranchesPages;
    // return this.get(studentBranchesPages);
    // let x = Hjson.parse(studentBranchesPages);
    // let y;
    // x.forEach(element => {
    //   if (element.route == sb)
    //   y = element;
    // });
    // console.log(y);
    // return y;
    
    //let _studentBranchesPages = (studentBranchesPages as any).default;
    //return _studentBranchesPages;
  }

  // Pages Titles And Descriptions
  getSignUpText(){
    return this.get(signUp);
    // let _signUp = (signUp as any).default;
    // return _signUp;
  }
  getContactUsText(){
    return this.get(contactUs);
    // let _contactUs = (contactUs as any).default;
    // return _contactUs;
  }
  getBlogText(){
    return this.get(blog);
    // let _blog = (blog as any).default;
    // return _blog;
  }
  getAboutUsText(){
    return this.get(aboutUs);
    // let _aboutUs = (aboutUs as any).default;
    // return _aboutUs;
  }
  
  
}
